import * as React from 'react';

export const PlusIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.9988 0H4.0012V4.00119H0V5.9988H4.0012V9.99999H5.9988V5.9988H10V4.00119H5.9988V0Z" fill={props.fill || '#4587EC'} />
    </svg>
  );
};
